import React from 'react';
import styles from './Hero.module.css';

const Hero: React.FC = () => (
  <div className={styles.heroTile}>
    <div className={styles.mlabel}>
      <span><span className={styles.glyph}>▦</span> Oak Cliff · Dallas, TX</span>
      <span className={styles.mno}>00</span>
    </div>
    {/* The stacked mark, set live: OAK / CLIFF / TECH, TECH in brick (BRAND.md §6) */}
    <h1 className={styles.wordmark} aria-label="Oak Cliff Tech">
      <span className={styles.line}>Oak</span>
      <span className={styles.line}>Cliff</span>
      <span className={`${styles.line} ${styles.tech}`}>Tech</span>
    </h1>
    <p className={styles.tagline}>
      Where Oak&nbsp;Cliff's designers, developers, engineers, and founders find each other.
    </p>
  </div>
);

export default Hero;
